import { Button } from '@crm/ui';
import { Link } from 'react-router-dom';
import { AUTH_ROUTES } from '@/modules/auth/constants';

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-4 text-center">
      <p className="text-5xl font-bold tracking-tight">404</p>
      <p className="text-muted-foreground">Essa pagina nao existe.</p>
      <Button asChild>
        <Link to={AUTH_ROUTES.DASHBOARD}>Voltar ao inicio</Link>
      </Button>
    </div>
  );
}
